export default "__VITE_ASSET__50Ea4UXr__"